import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import BSCWalletButton from "./BSCWalletButton";
import SocialButton from "./SocialButton";
import { MenuOutlined, CloseOutlined } from "@ant-design/icons";
import "../styles/Navbar.css";
import { Dropdown, Menu } from "antd";

interface NavbarProps {
  language: "en" | "zh";
}

const Navbar: React.FC<NavbarProps> = ({ language }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const leaderboardMenu = (
    <Menu className="leaderboard-dropdown-menu">
      <Menu.Item
        key="coin-battle"
        onClick={() => {
          navigate("/leaderboard");
          setMobileMenuOpen(false);
        }}
      >
        币圈大乱斗排行榜
      </Menu.Item>
    </Menu>
  );

  return (
    <header className="navbar">
      <div className="navbar-logo" onClick={() => navigate("/")}>
        <h3>novacrafterlab</h3>
      </div>

      <div className="mobile-menu-toggle" onClick={toggleMobileMenu}>
        {mobileMenuOpen ? <CloseOutlined /> : <MenuOutlined />}
      </div>

      <nav className={`navbar-menu ${mobileMenuOpen ? "active" : ""}`}>
        <span
          className={`nav-link${
            location.pathname === "/products" ? " active" : ""
          }`}
          onClick={() => {
            navigate("/products");
            setMobileMenuOpen(false);
          }}
        >
          {language === "en" ? "Products" : "产品"}
        </span>
        <span
          className={`nav-link${
            location.pathname === "/bridge" ? " active" : ""
          }`}
          onClick={() => {
            navigate("/bridge");
            setMobileMenuOpen(false);
          }}
        >
          {language === "en" ? "Bridge" : "桥接"}
        </span>
        <span
          className={`nav-link${
            location.pathname === "/clubs" ? " active" : ""
          }`}
          onClick={() => {
            navigate("/clubs");
            setMobileMenuOpen(false);
          }}
        >
          {language === "en" ? "Clubs" : "俱乐部"}
        </span>

        <span
          className={`nav-link${
            location.pathname === "/market" ? " active" : ""
          }`}
          onClick={() => {
            navigate("/market");
            setMobileMenuOpen(false);
          }}
        >
          {language === "en" ? "Market" : "市场"}
        </span>

        <span
          className={`nav-link${location.pathname === "/hub" ? " active" : ""}`}
          onClick={() => {
            navigate("/hub");
            setMobileMenuOpen(false);
          }}
        >
          {language === "en" ? "News" : "新闻"}
        </span>
        <span
          className={`nav-link${
            location.pathname === "/gallery" ? " active" : ""
          }`}
          onClick={() => {
            navigate("/gallery");
            setMobileMenuOpen(false);
          }}
        >
          {language === "en" ? "Gallery" : "图鉴"}
        </span>
        <Dropdown
          overlay={leaderboardMenu}
          trigger={["click"]}
          placement="bottomCenter"
        >
          <span className="nav-link" style={{ cursor: "pointer" }}>
            {language === "en" ? "Leaderboard" : "排行榜"}
          </span>
        </Dropdown>
        <span
          className={`nav-link${
            location.pathname === "/rewards" ? " active" : ""
          }`}
          onClick={() => {
            navigate("/rewards");
            setMobileMenuOpen(false);
          }}
        >
          {language === "en" ? "Rewards" : "活动🔥"}
        </span>
      </nav>

      <div className="navbar-actions">
        <div className="wallet-search-section">
          <SocialButton />
          <BSCWalletButton />
          <div className="search-box">
            <input
              type="text"
              placeholder={language === "en" ? "Search" : "搜索"}
            />
            <button className="search-button">
              <span>🔍</span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
